export default "/images/a8ff48c63f331b36166bcd396fbf5ef3.avif";